module.exports = __webpack_public_path__ + "img/2007.49369e58.png";